function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9129 5.75079C10.7349 4.72695 9.26506 4.72695 9.08705 5.75079C9.03854 6.02983 8.76605 6.18329 8.50342 6.28931C8.48058 6.29853 8.45785 6.30796 8.43522 6.31758C8.17429 6.4286 7.87276 6.51303 7.64086 6.34982C6.79103 5.75173 5.75173 6.79103 6.34982 7.64086C6.51303 7.87276 6.4286 8.17429 6.31758 8.43522C6.30796 8.45784 6.29853 8.48057 6.28932 8.50341C6.18329 8.76605 6.02984 9.03854 5.75079 9.08705C4.72695 9.26506 4.72695 10.7349 5.75079 10.9129C6.02984 10.9614 6.18329 11.2339 6.28932 11.4965C6.29854 11.5193 6.30796 11.5421 6.31758 11.5647C6.4286 11.8256 6.51303 12.1271 6.34982 12.3591C5.75173 13.2089 6.79103 14.2482 7.64086 13.6501C7.87277 13.4869 8.17431 13.5713 8.43525 13.6823C8.45786 13.692 8.48057 13.7014 8.50339 13.7106C8.76603 13.8166 9.03854 13.9701 9.08705 14.2491C9.26506 15.273 10.7349 15.273 10.9129 14.2491C10.9614 13.9701 11.2339 13.8166 11.4965 13.7106C11.5193 13.7014 11.5421 13.6919 11.5647 13.6823C11.8256 13.5713 12.1271 13.4869 12.359 13.6501C13.2089 14.2482 14.2482 13.2089 13.6501 12.3591C13.4869 12.1271 13.5713 11.8256 13.6823 11.5647C13.692 11.5421 13.7014 11.5193 13.7106 11.4965C13.8166 11.2339 13.9701 10.9614 14.2491 10.9129C15.273 10.7349 15.273 9.26506 14.2491 9.08705C13.9701 9.03854 13.8166 8.76605 13.7106 8.50341C13.7014 8.48058 13.692 8.45785 13.6823 8.43523C13.5713 8.17429 13.4869 7.87276 13.6501 7.64086C14.2482 6.79103 13.2089 5.75173 12.359 6.34982C12.1272 6.51303 11.8256 6.4286 11.5647 6.31758C11.5421 6.30796 11.5193 6.29853 11.4965 6.28931C11.2339 6.18329 10.9614 6.02983 10.9129 5.75079ZM12 9.99995C12 11.1045 11.1045 11.9999 9.99996 11.9999C8.89539 11.9999 7.99996 11.1045 7.99996 9.99995C7.99996 8.89538 8.89539 7.99995 9.99996 7.99995C11.1045 7.99995 12 8.89538 12 9.99995Z",
  fill: "white"
});

var SvgSettingsPageMobileNav = function SvgSettingsPageMobileNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSettingsPageMobileNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SettingsPageMobileNav.0cbfc8e3.svg";
export { ForwardRef as ReactComponent };